import { render } from "./order_admin.vue?vue&type=template&id=711a8924&scoped=true"
import script from "./order_admin.vue?vue&type=script&lang=js"
export * from "./order_admin.vue?vue&type=script&lang=js"

import "./order_admin.vue?vue&type=style&index=0&id=711a8924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711a8924"]])

export default __exports__